import { render, staticRenderFns } from "./UserRow.vue?vue&type=template&id=3137a730&scoped=true&"
import script from "./UserRow.vue?vue&type=script&lang=ts&"
export * from "./UserRow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3137a730",
  null
  
)

export default component.exports